import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BenefitsImageWrapper from "./BenefitsImageWrapper";
import BenefitsDetails from "./BenefitsDetails";
import Title from "../../../../utils/title/Title";
import { IHeaderType } from "../../../../types/types";
import { Colors } from "../../../../utils/colors/colors";
import styled from "styled-components";




export default function BenefitsFrom1KB() {
  const { secondaryColor, primaryColor } = Colors();

  return (
    <section
      id="benefits"
      className="section benefits py-4"
      style={{
        marginTop: "40px",
      }}
    >
      <Container>
        <Row
          style={{
            marginTop: "80px",
          }}
        >
          <MainTitleWrapper>
            <Title
              textColor={primaryColor}
              text={"The Benefits of the"}
              style={{
                margin: 0,
                fontWeight: 700,
                fontSize: "40px",
              }}
              type={IHeaderType.h3}
            />
            <TitleWrapper>
              <Title
                textColor={secondaryColor}
                text={"Eratek "}
                style={{
                  margin: 0,
                  fontWeight: 700,
                  fontSize: "40px",
                }}
                type={IHeaderType.h3}
              />
              <Title
                textColor={primaryColor}
                text={"1KB Initiative"}
                style={{
                  margin: 0,
                  fontWeight: 700,
                  fontSize: "40px",
                }}
                type={IHeaderType.h3}
              />
            </TitleWrapper>
          </MainTitleWrapper>
        </Row>

        <Row
          style={{
            marginTop: "6rem",
          }}
        >
          <Col
            sm={{ span: 12, order: 1 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 5, order: 1 }}
            style={{
              paddingRight: "3rem",
            }}
          >
            <BenefitsImageWrapper />
          </Col>

          <Col
            xs={{ span: 12, order: 2 }}
            md={{ span: 12, order: 2 }}
            lg={{ span: 7, order: 2 }}
          >
            <BenefitsDetails />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

const MainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;
